<template>
  <div>
    <v-row v-if="paramsFormulaire">
      <v-col cols="12" md="6">
        <don-side-info></don-side-info>
      </v-col>
      <v-col cols="12" md="6">
        <don-form></don-form>
      </v-col>
    </v-row>
    <div class="my-12" v-else>
      <p class="text-center">Un instant svp...</p>
      <p class="text-center">
        <v-progress-circular indeterminate :size="50"></v-progress-circular>
      </p>
    </div>
  </div>
</template>

<script>
import DonSideInfo from "../components/donate/info";
import DonForm from "../components/donate/form";
import { mapActions, mapMutations, mapGetters } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ paramsFormulaire: "getParamsFormulaire" }),
  },
  created() {
    this.setCampagne(this.$route.params.campagneId);
    this.loadParamsFormulaire(this.$route.params.campagneId);
  },
  methods: {
    ...mapActions(["loadParamsFormulaire"]),
    ...mapMutations(["setCampagne"]),
  },
  components: {
    DonSideInfo,
    DonForm,
  },
};
</script>

<style>
</style>